export default __webpack_public_path__ + "static/media/housing.a027ed23.svg";